import { render, staticRenderFns } from "./Series_Wise_report.vue?vue&type=template&id=0682b35f&scoped=true&"
import script from "./Series_Wise_report.vue?vue&type=script&lang=js&"
export * from "./Series_Wise_report.vue?vue&type=script&lang=js&"
import style0 from "./Series_Wise_report.vue?vue&type=style&index=0&id=0682b35f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0682b35f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBreadcrumbs,VBtn,VRow,VSimpleTable,VSkeletonLoader,VSnackbar})
